export default __webpack_public_path__ + "static/media/lp-sec05_bg1145.daa1ca55.png";